import { all } from "redux-saga/effects";
import { createUserFlow, saveUserFlow } from "./modules/users/sagas";
import { changePasswordFlow } from "./modules/profile/sagas";
import { saveGroupFlow } from "./modules/groups/sagas";
import { postCommentFlow } from "./modules/issues";
import { issuesFlow } from "./modules/_BETA/issues";
import { watchCreateAndAssociate } from "./modules/_BETA/issue";
import { associateEquipRuleFlow } from "./modules/_BETA/associate";
import { unassociateEquipRuleWatcher } from "./modules/_BETA/unassociate";
import { snoozeEquipRuleFlow } from "./modules/_BETA/snooze";
import { unsnoozeEquipRuleFlow } from "./modules/_BETA/unsnooze";
import {
  shouldRequestIssuesFlow,
  shouldRequestInsightsFlow,
  shouldRequestMonitoringFlow,
  shouldRequestMonthlySummaryFlow,
} from "./modules/_BETA/requestSchedule";
import { selectionsFlow } from "./modules/_BETA/selections";
import { userSitesFlow } from "./modules/userSites/sagas";
import { addAttachmentFlow } from "./modules/attachments/sagas";
import { logout, analyticsIdentify } from "./modules/auth/sagas";
import { watchGenerateReport } from "./modules/reportGenerator";
import { monthlySummarySagaFlow } from "./modules/monthlySummary/sagas";
import { appSetupFlow } from "./modules/appSetup/sagas";
import { loadMonitoring } from "./modules/monitoring/sagas";

import {
  loadActionFlow,
  loadRulesFlow,
  loadInitialActionFlow,
  saveActionFlow,
  addActionFlow,
} from "./modules/action/sagas";

export function* rootSaga() {
  yield all([
    appSetupFlow(),
    logout(),
    createUserFlow(),
    saveUserFlow(),
    changePasswordFlow(),
    saveGroupFlow(),
    monthlySummarySagaFlow(),
    addAttachmentFlow(),
    postCommentFlow(),
    analyticsIdentify(),
    watchGenerateReport(),

    // BETA Sagas
    issuesFlow(),
    watchCreateAndAssociate(),
    selectionsFlow(),
    associateEquipRuleFlow(),
    unassociateEquipRuleWatcher(),
    snoozeEquipRuleFlow(),
    unsnoozeEquipRuleFlow(),
    shouldRequestIssuesFlow(),
    shouldRequestInsightsFlow(),
    shouldRequestMonitoringFlow(),
    shouldRequestMonthlySummaryFlow(),
    userSitesFlow(),

    // New action flow
    loadActionFlow(),
    loadInitialActionFlow(),
    loadRulesFlow(),
    saveActionFlow(),
    addActionFlow(),

    loadMonitoring(),
  ]);
}
